import Typography from "@mui/material/Typography";

interface NameWithCodeProps {
  name: string | null;
  code: string;
}

/** A catalogue name over its code; the code stands in for a name the master no longer has. */
export default function NameWithCode({ name, code }: NameWithCodeProps) {
  return (
    <>
      <Typography variant="body2">{name ?? code}</Typography>
      <Typography variant="caption" color="text.secondary">
        {code}
      </Typography>
    </>
  );
}
